import http from '../http'

export const login = data => {
  return http.request({
    url: '/auth/login',
    data,
    method: 'post'
  })
}

export const logout = data => {
  return http.request({
    data,
    method: 'post'
  })
}

export const getLanguage = data => {
  return http.request({
    url: '/auth/getLanguage',
    data,
    method: 'post'
  })
}
